/*
  TODO - Implementar demais regras de validações
   Input Number: Requerido não funciona, pois diz que date não é uma String e ele não pega o tamanho mínimo e máximo;
   Input Date: Requerido não funciona, pois diz que date não é uma String;
   Input Date and Time: Requerido não funciona, pois diz que date não é uma String;
*/

import Vue from 'vue'
import i18n from 'src/i18n';

var moment = require('moment');
const vue = new Vue();

export default {

  resolveRules: function (attr, rules) {

    if (!rules) {
      throw new Error("SGSUtils > resolveRules > rules undefined");
    }

    let requiredMessage = 'Por favor, preencha o campo';
    let requiredFile = 'Por favor, selecione um arquivo';
    let minSize = 'Tamanho mínimo';
    let maxSize = 'Tamanho máximo';
    let maxValue = 'Valor máximo';
    let requiredNumber = 'Por favor, preencha com um número válido';

    if (i18n.locale == 'es') {

      requiredMessage = 'Por favor, rellene el campo';
      requiredFile = 'Por favor, seleccione un archivo';
      minSize = 'Tamaño mínimo';
      maxSize = 'Tamaño máximo';
      maxValue = 'Valor máximo';
      requiredNumber = 'Por favor, rellene con un número válido';

    } else if (i18n.locale == 'en') {

      requiredMessage = 'Please fill in the field';
      requiredFile = 'Please select a file';
      minSize = 'Minimum size';
      maxSize = 'Maximum size';
      maxValue = 'Maximum value';
      requiredNumber = 'Please fill in with a valid number';

    }

    rules[attr.columnName] = [];

    if (attr.required) {
      if (attr.type == "text" || attr.type == "filterText") {
        rules[attr.columnName].push({required: true, message: requiredMessage, trigger: 'blur'});
      } else if (attr.type == "time") {
        rules[attr.columnName].push({required: true, message: requiredMessage, trigger: 'blur'});
      } else if (attr.type == "cnpj") {
        rules[attr.columnName].push({required: true, message: requiredMessage, trigger: 'blur'});
      } else if (attr.type == "cpf") {
        rules[attr.columnName].push({required: true, message: requiredMessage, trigger: 'blur'});
      } else if (attr.type == "email") {
        rules[attr.columnName].push({required: true, message: requiredMessage, trigger: 'blur'});
      } else if (attr.type == "textArea") {
        rules[attr.columnName].push({required: true, message: requiredMessage, trigger: 'blur'});
      } else if (attr.type == "association") {
        rules[attr.columnName].push({required: true, message: requiredMessage, trigger: 'change'});
      } else if (attr.type == "date" || attr.type == "filterDate") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
      } else if (attr.type == "dateTime") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
      } else if (attr.type == "composition") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
        rules[attr.columnName].push({type: 'number', message: requiredMessage});
      } else if (attr.type == "map") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
      } else if (attr.type == "password") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
      } else if (attr.type == "phone") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
      } else if (attr.type == "charges") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
      } else if (attr.type == "dealership") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
      } else if (attr.type == "inputCSV") {
        rules[attr.columnName].push({required: true, message: requiredFile});
      } else if (attr.type == "textEditor") {
        rules[attr.columnName].push({required: true, message: requiredMessage});
      }
    }

    if (attr.type == "numeric") {

      let numericRule = {
        validator: (rule, value, callback) => {

          if (value && isNaN(value)) {
            callback(new Error(requiredNumber));
          }

          if (attr.minValue > 0 && !(attr.minValue <= value)) {
            callback(new Error(minSize + ' ' + attr.minValue));
          }

          if (attr.maxValue > 0 && !(value <= attr.maxValue)) {
            callback(new Error(maxValue + ' ' + attr.maxValue));
          }

          callback();
        }
      };

      rules[attr.columnName].push(numericRule);
    }

    if (attr.type == "float") {

      let floatRule = {
        validator: (rule, value, callback) => {

          let totalDigits = attr.totalDigits;
          let decimalDigits = attr.decimalDigits;
          let max = "".padEnd(totalDigits - decimalDigits, "9");
          max = max + ".".padEnd(decimalDigits + 1, "9");

          if (value > max) {
            callback(new Error(maxValue + " " + max));
          } else {
            callback();
          }
        }
      };

      rules[attr.columnName].push(floatRule);
    }

    if (attr.minSize > 0) {
      rules[attr.columnName].push({
        min: attr.minSize,
        message: minSize + ' ' + attr.minSize,
        trigger: 'blur'
      });
    }
    if (attr.maxSize > 0) {
      rules[attr.columnName].push({
        max: attr.maxSize,
        message: maxSize + ' ' + attr.maxSize,
        trigger: 'blur'
      });
    }
  },

  formatField: function(value, type) {
    return this.formatField2({
      value: value,
      type: type
    });
  },

  formatField2: function(params) {

    if (!params) {
      return "";
    }

    let value = params.value;
    let type = params.type;
    let misc = params.misc;

    if (value === undefined) {
      return "";
    }

    let ret = '';

    if(type == 'boolean' && misc !== undefined && misc.yes !== undefined && misc.no !== undefined) {
      ret = value == 'YES' ? misc.yes : misc.no;
    } else if(type == 'boolean') {
      ret = value == 'YES' ? 'Sim' : 'Não';
    } else if(type == 'date') {
      let date = new Date(value + " 00:00:00");
      ret = moment(date).format('DD/MM/YYYY');
    } else if(type == 'dateTime') {
      let date = new Date(value);
      ret = moment(date).format('DD/MM/YYYY HH:mm');
    } else if(type == 'time') {
      if(value) {
        let time = value.split(":");
        ret = time[0] + ":" + time[1];
      } else {
        ret = value;
      }
    } else {
      ret = value;
    }

    return ret;
  },

  getPlaceholder: function(attr) {
    return this.getPlaceholder(attr, null);
  },

  getPlaceholder: function(attr, locale) {

    if (attr != undefined && attr.placeholderPt != undefined && attr.placeholderPt != "") {

      let placeholder = attr.placeholderPt;

      if (locale == 'es' && attr.placeholderEs != undefined && attr.placeholderEs != "") {
        placeholder = attr.placeholderEs;
      } else if (locale == 'en' && attr.placeholderEn != undefined && attr.placeholderEn != "") {
        placeholder = attr.placeholderEn;
      }

      return placeholder;
    }

    return ""
  },

  getLabel: function(params) {

    if (!params) {
      return "";
    }

    let attr = params.attr;
    let locale = params.locale;
    let label = params.label ? params.label : "";

    if (attr != undefined && attr.labelPt != undefined && attr.labelPt != "") {

      label = attr.labelPt;

      if (locale == 'es' && attr.labelEs != undefined && attr.labelEs != "") {
        label = attr.labelEs;
      } else if (locale == 'en' && attr.labelEn != undefined && attr.labelEn != "") {
        label = attr.labelEn;
      }

      return label;
    }

    return label;
  },

  getHint: function(params) {

    if (!params) {
      return "";
    }

    let attr = params.attr;
    let locale = params.locale;
    let hint = "";

    if (attr != undefined && attr.hintPt != undefined && attr.hintPt != "") {

      hint = attr.hintPt;

      if (locale == 'es' && attr.hintEs != undefined && attr.hintEs != "") {
        hint = attr.hintEs;
      } else if (locale == 'en' && attr.hintEn != undefined && attr.hintEn != "") {
        hint = attr.hintEn;
      }

      return hint;
    }

    return hint;
  }
}



// WEBPACK FOOTER //
// ./src/components/utils/sgs/SgsUtils.js